import { useEffect } from 'react';
import { useSession } from '@/app/session-context';
import { applyAnalyticsConsent } from '@/lib/analytics';
import { onConsentChange } from '@/lib/consent';

/**
 * Brings analytics and crash reporting in line with the stored answer: once
 * at boot, and again whenever the answer changes from the prompt or from
 * Settings. Renders nothing. Lives inside the session provider because the
 * age gate is on the profile, and a minor is never tracked whatever is stored.
 */
export function PrivacyBoot() {
  const { profile } = useSession();
  const minor = profile.flags.minor;

  useEffect(() => {
    void applyAnalyticsConsent({ minor });
    return onConsentChange(() => void applyAnalyticsConsent({ minor }));
  }, [minor]);

  return null;
}
